export default __webpack_public_path__ + "static/media/city-coach.935329fb.png";